<div class="project-details-custom-forms-list"  [ngClass]="{'with-overlay': (modalView != MODAL_VIEW_NONE) }">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == MODAL_VIEW_MODAL_LEAVE"
        [type]="'warning'"
        [message]="'Discard Form Changes'"
        [text]="'You have not saved all your form values yet. Are you sure you want to leave and discard your changes?'"
        [buttonText]="'Discard'"
        [secondButtonText]="'Go Back'"
        (action)="onLeave($event)"
        (secondButtonAction)="onStay($event)"
    ></core-layout-modal-feedback>
    <div class="loader" *ngIf="loading$ | async; else dataContent">

        <div class="dimmed">
            <div class="dimmed_nav">
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
            </div>
        </div>
    </div>
    <!--  -->
    <ng-template #dataContent>
        <div *ngIf="(forms$ | async)?.length > 0; else handleNoDataOrError">
            <ul class="custom-forms-list">
                <ng-container *ngFor="let form of (forms$ | async | sortBy: 'name' : 'asc')">
                    <core-helpers-lists-one-action-list-item [title]="form.name" (titleClick)="onToggle(form)">
                    </core-helpers-lists-one-action-list-item>
                    <ng-container *ngIf="isOpen(form)">
                        <div class="custom-forms-list-item">
                            <!-- when has no data yet -->
                            <ng-container *ngIf="form.submittable; else formViewMode">
                                <project-details-forms-fill-main 
                                    [customForm]="form" 
                                    (cancel)="onCancel(form)"
                                    (collapsible)="onCanCollapse(form.uuid, $event)"
                                >
                                </project-details-forms-fill-main>
                            </ng-container>

                            <!-- When alredy have data filled -->
                            <ng-template #formViewMode>
                                <project-details-forms-view-main [customForm]="form"> 
                                </project-details-forms-view-main>
                                <!-- [value]="data"    pending     to add    -->
                            </ng-template>


                        </div>
                    </ng-container>
                </ng-container>
            </ul>
        </div>
        <!-- Template for handling both no data and errors -->
        <ng-template #handleNoDataOrError>
            <div class="custom-forms-errors"  *ngIf="error$ | async as error; else noData">
                <div [ngSwitch]="error.status">
                    <!-- TO REVIEW ng17 when ngSwitch check values directly due to strict comparison -->
                    <!-- Error handling for each status -->
                    <div *ngSwitchCase="404" class="error">
                        <core-helpers-box-http-error
                            [code]="404"
                            [message]="'Not found. Check your URL.'"
                        ></core-helpers-box-http-error>
                    </div>
                    <div *ngSwitchCase="403" class="error">
                        <core-helpers-box-http-error
                            [code]="403"
                            [message]="'Not allowed.'"
                        ></core-helpers-box-http-error>
                    </div>
                    <div *ngSwitchCase="500" class="error">
                        <core-helpers-box-http-error
                            [code]="500"
                            [message]="'Internal server error, please refresh your browser. If the error persists, please reach out to our support team through the Help Me button.'"
                        ></core-helpers-box-http-error> 
                    </div>
                    <div *ngSwitchDefault class="error">
                        <core-helpers-box-http-error 
                            [code]="''"
                            [message]="'Internal server error, please refresh your browser. If the error persists, please reach out to our support team through the Help Me button.'"
                        ></core-helpers-box-http-error>
                    </div>
                </div>
            </div>

            <ng-template #noData>
                <article class="forms-not-content">
                    <core-helpers-box-alert-message-icon [text]="'There are currently no forms.'"
                        [icon]="'no_messages'"></core-helpers-box-alert-message-icon>
                </article>
            </ng-template>
        </ng-template>

    </ng-template>
</div>